// extracted by mini-css-extract-plugin
export default {"content":"Page404_500_content__HgihJ","error_code":"Page404_500_error_code__qXPr8","link":"Page404_500_link__2uoqQ"};